/* eslint-disable */
import NProgress from 'nprogress'; // progress bar
import router from './index';
import store from '../store';

import 'nprogress/nprogress.css'; // progress bar style

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = [
  '/busqueda-del-predio',
  '/requisitos-para-descuentos-especiales',
  '/cobro-de-avaluos',
];

// TODO: eliminar esta linea antes de prod
whiteList.push('/confirmacion-pago-con-bancomer');
whiteList.push('/confirmacion-pago-con-santander');

/**
 * Verifica que la aplicación sea consumida a travez de
 * un web view
 * @returns {Boolean}
 */
const validateWebView = () => store.state.app.isWebView;

/**
 * Verifica que exista una búsqueda de predio
 * en el estado global de la aplicación
 * @returns {Boolean}
 */
const hasPredio = () => {
  try {
    return !!store.state.predio.data.length;
  } catch (error) {
    return false;
  }
};

/**
 * Verifica que haya elementos a pagar en el estado
 * global de la aplicación
 * @returns {Boolean}
 */
const hasCart = () => {
  try {
    return !!store.state.cart.data.total;
  } catch (error) {
    return false;
  }
};

const hasPedingCharges = () => {
  try {
    return store.state.predio.data.some((x) => x.checked === true
      && /impuesto predial/i.test(x.observaciones));
  } catch (error) {
    return false;
  }
};

const hasPayedCharges = () => {
  try {
    return !!(store.state.receipt.data.curt || store.state.receipt.receiptPDF);
  } catch (error) {
    return false;
  }
};

const hasNoDebtsCertificatePaymentPending = () => {
  try {
    return !!store.state.certificate.predio_oid;
  } catch {
    return false;
  }
};

const hasAvaluosInfo = () => {
  try {
    return !!(store.state.avaluos.Folio
      && store.state.avaluos.Importe
      && store.state.avaluos.Descripcion);
  } catch {
    return false;
  }
};

const hasAvaluosReceipts = () => {
  try {
    return !!(store.state.avaluos.receipts?.length);
  } catch {
    return false;
  }
};
const paymentRoutes = ['/pagar', '/movil'];

// const hasQueryParams = (route) => Object.keys(route.query).length > 0;

// Evento BeforeEach: Se ejecuta antes de ingresar a cada pantalla o ruta.
router.beforeEach((to, from, next) => {
  try {
    NProgress.start();

    const keys = Object.keys(to.query);
    if (keys.includes('isWebView')) {
      store.dispatch('app/SET_IS_WEB_VIEW', to.query.isWebView === 'true');
    }

    // set window title
    document.title = `Zapopan - ${to?.meta?.title?.trim()}`;

    // Persist Query params
    // if (!hasQueryParams(to) && hasQueryParams(from)) {
    //   return next({ name: to.name, query: from.query });
    // }

    // normalize route
    const route = to.path.toLowerCase();
    if (whiteList.includes(route)) {
      NProgress.done();
      return next();
    }

    if (/\/movil/g.test(route) && !validateWebView()) {
      return next({ path: whiteList[0], query: from.query });
    }

    if (route === '/pagar-constancia' && hasNoDebtsCertificatePaymentPending()) {
      return next();
    }

    if (hasPredio()) {
      // Si no tiene elementos a pagar, bloquear el acceso a al ruta de pago.
      if (paymentRoutes.some((r) => new RegExp(r, 'g').test(route)) && !hasCart()) {
        NProgress.done();
        return next({ path: 'detalles-de-pago' });
      }
      if (!hasPedingCharges() && route !== '/resumen-de-adeudo') {
        NProgress.done();
        return next({ path: 'resumen-de-adeudo', query: from.query });
      }
      NProgress.done();
      return next();
    }

    if (route === '/recibo-de-pago' || route === '/recibo-pdf') {
      if (hasPayedCharges()) {
        NProgress.done();
        return next();
      }
      NProgress.done();
      return next();
    }

    if (route === '/pagar-avaluos' && hasAvaluosInfo()) {
      NProgress.done();
      return next();
    }

    if (route === '/recibos-avaluos' && !hasAvaluosReceipts()) {
      NProgress.done();
      return next();
    }

    NProgress.done();
    // Si no tiene una búsqueda, retorna a la página de consulta.
    return next({ path: whiteList[0], query: from.query });
  } catch (err) {
    return err;
  }
});
